<!-- <app-note-personali note=""></app-note-personali> -->
<ng-template appPlaceholder></ng-template>
<app-mat-spinner-overlay overlay="true" *ngIf="isLoading"></app-mat-spinner-overlay>
<nav class="navbar navbar-expand-lg" id="header-container">
    <!-- <a class="navbar-brand" routerLink="/" style="color: #1fa799;font-weight:bold;">
        <img src="assets/img/logo.png" alt="" width="40" height="40" class="d-inline-block align-top">
    </a> -->
    <button class="navbar-toggler" type="button" (click)="collapsed = !collapsed">
        <mat-icon>menu</mat-icon>
    </button> 
    <div 
        class="navbar-collapse"  
        [class.collapse]="collapsed"
        (window:resize)="collapsed = true"
        id="navbarSupportedContent"
        style="position: relative;"
        *ngIf="isAuth">

        <ul class="navbar-nav mr-auto" style="margin-left: 85vw;">
            <li class="nav-item" style="margin-right: 10px;">
                <input (click)="setLanguage('en')" style="height: 20px; width: 20px;" type="image" src="assets/img/english_flag.png"/>
            </li>
            <li class="nav-item">
                <input (click)="setLanguage('it')" style="height: 20px; width: 20px;" type="image" src="assets/img/italian_flag.png"/>
            </li>
        </ul>
    
    
        <!-- <ul class="navbar-nav mr-auto">
            <li 
                class="nav-item"
                *ngFor="let icon of menu">
                <mat-icon
                    *ngIf="!icon.dropdown"
                    matTooltip="{{'headerMenu.' + icon.nav | translate}}"
                    routerLink="{{icon.nav}}"
                    routerLinkActive="active"
                    (click)="collapsed = true">
                {{icon.label}}
                </mat-icon>
                <div 
                    class="d-inline-block"
                    *ngIf="icon.dropdown">
                    <mat-icon 
                        class="dropdown-toggle"
                        matTooltip="{{'headerMenu.' + icon.nav | translate}}"
                        mat-button
                        [matMenuTriggerFor]="test">
                        {{ icon.label }}
                    </mat-icon>
                    <mat-menu
                        #test
                        yPosition="below">
                        <button
                            *ngFor="let menuVoice of icon.dropdown"
                            mat-menu-item>
                            <mat-icon (click)="collapsed = true">{{ menuVoice.label }}</mat-icon>
                            {{'headerMenu.' + menuVoice.nav | translate}}
                        </button>
                    </mat-menu>
                </div>
            </li>
            
        </ul> -->
        <div 
            class="form-inline my-2 my-lg-0"
            style="padding-right: 40px;">

            <!-- <ul class="navbar-nav mr-auto"> -->
                <!-- <li class="nav-item">
                    <mat-icon 
                        matTooltip="{{ 'headerInfo' | translate }}"
                        (click)="onShowAbout()">info</mat-icon>
                </li> -->
                <!-- <li class="nav-item" style="margin-right: 10px;">
                    <div class="d-inline-block">
                        <mat-icon 
                            class="dropdown-toggle" 
                            mat-button 
                            [matMenuTriggerFor]="helpMenu"
                            matTooltip="{{ 'headerHelp' | translate }}">help_outline</mat-icon>
                        <mat-menu #helpMenu yPosition="below"> -->
                            <!-- <a href="http://talmud.it" target="_blank" rel="noopener noreferrer" style="text-decoration-line: none;"> -->
                                <!-- <button disabled mat-menu-item>
                                    <mat-icon>folder_open</mat-icon>
                                    {{ 'headerHelpOnline' | translate }}
                                </button> -->
                            <!-- </a> -->
                            <!-- <a download="publishingGuide" target="_blank" href="../../assets/pdf/publishingGuide.pdf">
                                <button mat-menu-item>
                                    <mat-icon>description</mat-icon>
                                    {{ 'headerHelpPublishing' | translate }}
                                </button>
                            </a>
                        </mat-menu>
                    </div>
                </li> -->
                <!-- <li class="nav-item">
                    <mat-icon matTooltip="{{ 'headerAlert' | translate }}">error_outline</mat-icon>
                </li> -->
            <!-- </ul> -->
            <!-- <div> -->
            <!-- </div> -->
            <div class="d-inline-block">

                <mat-icon 
                    class="dropdown-toggle" 
                    style="font-size: 33px;margin-top:2px;"
                    mat-button [matMenuTriggerFor]="userMenu">account_circle</mat-icon>
                <mat-menu #userMenu yPosition="below">
                    <button mat-menu-item disabled>
                        <mat-icon>account_circle</mat-icon>
                        {{nome}}
                    </button>
                    <!-- <button mat-menu-item
                    (click)="onShowUtente()">
                        <mat-icon 
                        >settings</mat-icon>
                        {{ 'userSettings' | translate }} 
                    </button>
                    <button mat-menu-item
                    (click)="onShowNotePersonali()">
                        <mat-icon>edit</mat-icon>
                        {{ 'userNotes' | translate }}
                    </button> -->
                    <button mat-menu-item (click)="onLogout()">
                        <mat-icon>exit_to_app</mat-icon>
                        {{ 'userExit' | translate }}
                    </button>
                </mat-menu>
            </div>
        </div>
    </div>
</nav>